const SHARED_CODE_MESSAGES = {
  "auth/invalid-email": "Please enter a valid email address.",
  "auth/user-disabled": "This account has been disabled. Please contact support.",
  "auth/too-many-requests":
    "Too many attempts. Please wait a little and try again.",
  "auth/network-request-failed":
    "Network error. Please check your internet connection and try again.",
  "auth/requires-recent-login":
    "For security, please log in again and then retry this action.",
  "auth/expired-action-code":
    "This link has expired. Please request a new invitation link.",
  "auth/invalid-action-code":
    "This link is invalid or has already been used.",
  "permission-denied": "You do not have permission to do that.",
};

const CONTEXT_MESSAGES = {
  login: {
    "auth/user-not-found": "Invalid email or password.",
    "auth/wrong-password": "Invalid email or password.",
    "auth/invalid-credential": "Invalid email or password.",
    "auth/invalid-login-credentials": "Invalid email or password.",
  },
  register: {
    "auth/email-already-in-use": "An account with this email already exists.",
    "auth/weak-password":
      "Password is too weak. Please use at least 6 characters.",
    "auth/operation-not-allowed":
      "Email sign-up is not available right now. Please try again later.",
  },
  resetPassword: {
    "auth/user-not-found":
      "If an account exists for this email, a reset link will be sent.",
  },
  passwordChange: {
    "auth/wrong-password": "Your current password is incorrect.",
    "auth/invalid-credential": "Your current password is incorrect.",
    "auth/weak-password":
      "Your new password is too weak. Please use at least 6 characters.",
  },
  inviteAdmin: {
    "auth/invalid-email": "Please enter a valid admin email address.",
  },
  completeSignup: {
    "auth/weak-password":
      "Password is too weak. Please use at least 6 characters.",
  },
};

const FALLBACK_MESSAGES = {
  default: "Something went wrong. Please try again.",
  login: "Could not sign you in. Please try again.",
  register: "Could not create the account. Please try again.",
  resetPassword: "Could not send the reset email right now.",
  passwordChange: "Could not update the password. Please try again.",
  inviteAdmin: "Could not send the admin invitation. Please try again.",
  completeSignup: "Could not complete signup. Please try again.",
};

export function getAuthErrorMessage(error, context = "default") {
  const code = String(error?.code || "");
  const rawMessage = String(error?.message || "").trim();
  const customMessage =
    rawMessage && !rawMessage.startsWith("Firebase:") ? rawMessage : "";

  if (customMessage) {
    return customMessage;
  }

  if (CONTEXT_MESSAGES[context]?.[code]) {
    return CONTEXT_MESSAGES[context][code];
  }

  if (SHARED_CODE_MESSAGES[code]) {
    return SHARED_CODE_MESSAGES[code];
  }

  return FALLBACK_MESSAGES[context] || FALLBACK_MESSAGES.default;
}
